const { base64 } = require('ethers/lib/utils.js');
const cbridgeTxPb = require('./ts-proto/sgn/cbridge/v1/tx_pb.js');

async function getRequestOptions(transferId, estimatedReceivedAmt) {
    const withdrawReqProto = new cbridgeTxPb.WithdrawReq();
    withdrawReqProto.setXferId(transferId);
    withdrawReqProto.setReqId(Math.floor(Date.now() / 1000));
    withdrawReqProto.setWithdrawType(1);

    return {
        withdraw_req: base64.encode(withdrawReqProto.serializeBinary() || ''),
        estimated_received_amt: estimatedReceivedAmt,
        method_type: 2
    };
}

module.exports.default = getRequestOptions;
